import { useControlled } from "@mui/material";
import { useCallback, useImperativeHandle, useLayoutEffect, useRef, useState } from "react";
import { sectionName } from "../classes.js";
function useSectionState(props) {
  const {
    actions,
    defaultExpanded,
    actionBarVisibility,
    onChange: controlledOnChange,
    expanded: expandedControlled
  } = props;
  const [expanded, setExpanded] = useControlled({
    name: sectionName,
    state: "expanded",
    default: defaultExpanded,
    controlled: expandedControlled
  });
  const rExpanded = useRef(expanded);
  const rOnChange = useRef(controlledOnChange);
  useLayoutEffect(() => {
    rExpanded.current = expanded;
    rOnChange.current = controlledOnChange;
  }, [controlledOnChange, expanded]);
  const onChange = useCallback(
    (isExpanded) => {
      setExpanded(isExpanded);
      rOnChange?.current?.(isExpanded);
    },
    [setExpanded]
  );
  const open = useCallback(() => {
    onChange(true);
  }, [onChange]);
  const close = useCallback(() => {
    onChange(false);
  }, [onChange]);
  const toggle = useCallback(() => {
    onChange(!rExpanded.current);
  }, [onChange]);
  useImperativeHandle(
    actions,
    () => ({
      open,
      close,
      toggle
    }),
    [close, open, toggle]
  );
  const [state, setState] = useState(() => ({
    hover: false,
    actionBarOpen: false
  }));
  const onEnterHeader = useCallback(() => {
    setState((prevState) => ({ ...prevState, hover: true }));
  }, []);
  const onLeaveHeader = useCallback(() => {
    setState((prevState) => ({ ...prevState, hover: false }));
  }, []);
  const onChangedActionBar = useCallback((open2) => {
    setState((prevState) => ({
      ...prevState,
      actionBarOpen: open2,
      hover: open2 ? false : prevState.hover
    }));
  }, []);
  const actionBarVisible = actionBarVisibility === "hover" ? state.hover || state.actionBarOpen : true;
  return {
    expanded,
    onChange,
    onEnterHeader,
    onLeaveHeader,
    actionBarVisible,
    onChangedActionBar
  };
}
export {
  useSectionState
};
//# sourceMappingURL=useSectionState.js.map
